import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import GridPage from './GridPage.jsx';
import { enterPreviewMode } from '../../utils/preview/enterPreviewMode';

const PreviewPage = () => {
  const dispatch = useDispatch();
  const hasEnteredPreviewRef = useRef(false);

  const handleEnterPreview = useCallback(
    ({ scene, completeObject, handleReplay, startAllAnimations }) => {
      if (hasEnteredPreviewRef.current) return;
      hasEnteredPreviewRef.current = true;

      enterPreviewMode({
        dispatch,
        scene,
        currentWindowType: 'design',
        completeObject,
        handleReplay,
        startAllAnimations,
      });
    },
    [dispatch]
  );

  return (
    <div style={{ width: '100vw', height: '100vh', margin: 0 }}>
      <GridPage
        nobars
        enterPreviewOnMount
        onEnterPreview={handleEnterPreview}
      />
    </div>
  );
};

export default PreviewPage;
